module.exports = __webpack_public_path__ + "static/img/test.d4b6bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/test.png
// module id = uJ8T
// module chunks = 1